import React from "react";
import RingotelOrgForm from "../Form/RingotelOrgs";
import { RingotelOrg } from "../../hooks/apis/ringotel.api";
import ModalWrapper from "../generic/modal";
const EditRingtelOrgModal = ({
  setIsModalOpen,
  isModalOpen,
  editData,
}: {
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isModalOpen: boolean;
  editData: RingotelOrg | null;
}) => {
  return (
    <ModalWrapper
      title="Edit Organization"
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
    >
      <RingotelOrgForm editData={editData} setIsModal={setIsModalOpen} />
    </ModalWrapper>
  );
};

export default EditRingtelOrgModal;
